var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#6BE4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5013 24.1667H14.6716C13.6229 24.1667 13.0986 24.1667 12.9883 24.0852C12.8643 23.9938 12.8341 23.9398 12.8206 23.7863C12.8087 23.6497 13.1301 23.1239 13.7728 22.0722C14.4364 20.9863 14.9999 19.4052 14.9999 17.1667C14.9999 15.929 15.5267 14.742 16.4644 13.8668C17.4021 12.9917 18.6738 12.5 19.9999 12.5C21.326 12.5 22.5978 12.9917 23.5355 13.8668C24.4731 14.742 24.9999 15.929 24.9999 17.1667C24.9999 19.4052 25.5634 20.9863 26.2271 22.0722C26.8698 23.1239 27.1912 23.6497 27.1792 23.7863C27.1658 23.9398 27.1355 23.9938 27.0116 24.0852C26.9013 24.1667 26.3769 24.1667 25.3282 24.1667H22.4999M17.5013 24.1667L17.4999 25C17.4999 26.3807 18.6192 27.5 19.9999 27.5C21.3806 27.5 22.4999 26.3807 22.4999 25V24.1667M17.5013 24.1667H22.4999",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8ad77632ae3b97da8219873c70b5abf9.svg";
export { ForwardRef as ReactComponent };